<template>
    <div class="login">
        <div class="login-title">
            <span class="login-title-image"></span>
            <span class="login-title-text">停車場整合管理系統</span>
        </div>
        <form class="login__form" @submit.prevent @keyup.enter="postForgetPassword()">
            <div class="login__form__item router">
                <span class="router-title">忘記密碼</span>
                <router-link class="router-link-item" :to="`${root}/login`">{{$t("login.link.loginText")}}</router-link>
                <router-link class="router-link-item" :to="`${root}/login/signIn`">{{$t("login.link.signInText")}}</router-link>
            </div>
            <lgn-form-item label-position="top" class="login__form__item email">
                <div slot="label" class="login__form__item-label">帳號</div>
                <lgn-input slot="input" type="email" v-model="email" placeholder="Email (例:paca@berryan.com)"></lgn-input>
            </lgn-form-item>
            <lgn-form-item label-position="top" class="login__form__item password">
                <div slot="label" class="login__form__item-label">新密碼</div>
                <lgn-input slot="input" type="password" v-model="password" placeholder="最少 8 個字碼, 須包含英文及數字"></lgn-input>
            </lgn-form-item>
            <div class="login__form__item submit">
                <span class="submit-info">
                    <span class="submit-info-text">(送出後請至email收信, 並啟用帳號新密碼)</span>
                </span>
                <el-button class="submit-button main-button" @click="postForgetPassword()">送出</el-button>
            </div>
        </form>
    </div>
</template>
<script>
import * as api from "@/script/apiService/api.js"
import lgnInput from '@/lgnComponents/lgnInput/lgnInput.vue'
import lgnFormItem from '@/lgnComponents/lgnForm/lgnFormItem.vue'
export default {
    name: "forgetPassword",
    data(){
        return{
            email: "",
            password: "",
            root: process.env.VUE_APP_PACACLOUND_ROOT
        }
    },
    components: {
        lgnInput,
        lgnFormItem
    },
    methods: {
        async postForgetPassword(){
            let res = await api.postForgetPassword(this.email, this.password);
            if(!res.error_status){
                this.$message.success({
                    duration: 2500,
                    showColse: true,
                    message: "請至您的電子信箱確認"
                })
                this.$router.push(`${this.root}/login`);
            } else if(res.error_status == '400'){
                this.$message.error({
                    duration: 2500,
                    showColse: true,
                    message: "密碼不符合條件!"
                })
            } else if(res.error_status == '404'){
                this.$message.error({
                    duration: 2500,
                    showColse: true,
                    message: "此信箱尚未註冊!"
                })
            } else if(res.error_status != '401' && res.error_status != '504'){
                this.$message.error({
                    duration: 2500,
                    showColse: true,
                    message: "發生錯誤!"
                })
            }
        }
    }
}
</script>